import { memo, useEffect, useState } from "react";
import Animated, {
	runOnJS,
	useAnimatedStyle,
	useSharedValue,
	withTiming,
} from "react-native-reanimated";
import CenteredScrollView from "src/components/CenteredScrollView";
import useDevice from "src/hooks/useDevice";
import { paddingLarge, paddingMedium, paddingSmall } from "src/styles/spacing";
import { GatheringHeaderProps } from "../types";

const GatheringHeaderRowActions = ({
	renderRowActions,
	variant,
	hideRowActions = false,
}: Pick<GatheringHeaderProps, "variant" | "hideRowActions"> & {
	renderRowActions: NonNullable<GatheringHeaderProps["renderRowActions"]>;
}) => {
	const { device } = useDevice();
	const [isHidden, setIsHidden] = useState(false);
	const opacitySV = useSharedValue(hideRowActions ? 0 : 1);
	useEffect(() => {
		if (!hideRowActions) {
			setIsHidden(false);
		}
		opacitySV.value = withTiming(
			hideRowActions ? 0 : 1,
			{ duration: 200 },
			hideRowActions
				? () => {
						"worklet";
						runOnJS(setIsHidden)(true);
					}
				: undefined,
		);
	}, [hideRowActions, opacitySV]);
	const animatedStyle = useAnimatedStyle(
		() => ({
			opacity: opacitySV.value,
		}),
		[opacitySV],
	);

	return (
		<Animated.View
			pointerEvents={isHidden ? "none" : "auto"}
			style={[
				{
					flexDirection: "row",
					width: "100%",
					marginTop: variant === "Wide" ? paddingLarge : paddingMedium,
					justifyContent: "center",
				},
				animatedStyle,
			]}
		>
			<CenteredScrollView
				horizontal
				showsHorizontalScrollIndicator={false}
				contentContainerStyle={[
					{
						flexDirection: "row",
						alignItems: "center",
						justifyContent: variant === "Wide" ? "flex-start" : "center",
						columnGap: paddingMedium,
						paddingHorizontal: device === "mobile" ? paddingLarge : paddingMedium,
						paddingVertical: paddingSmall,
					},
				]}
				style={{
					width: "100%",
				}}
			>
				{renderRowActions()}
			</CenteredScrollView>
		</Animated.View>
	);
};
export default memo(GatheringHeaderRowActions);
